export { Partners } from './partners'
